import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { rhythm } from "../utils/typography"

const Badge = () => {
  const data = useStaticQuery(graphql`
    query BadgeQuery {
      badge: file(relativePath: { eq: "powered-by-electricity.png" }) {
        childImageSharp {
          fluid(maxWidth: 1600 ) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
      <div align="left" >
          <Img
              fluid={data.badge.childImageSharp.fluid}
              alt="Powered by Electricity"
          />
      </div>

  )
}

export default Badge
